// Client trust strip. Renders an <img> if a logo file exists at /logos/<file>,
// otherwise falls back to a clean, uniform text badge. Drop official logo PNGs
// into /app/frontend/public/logos/ (e.g. adani.png) to auto-upgrade to images.
import { useState } from "react";

const clients = [
  { name: "Adani", file: "adani.png" },
  { name: "L&T", file: "lnt.png" },
  { name: "Tata Projects", file: "tataprojects.png" },
  { name: "JLL", file: "jll.png" },
  { name: "MHADA", file: "mhada.png" },
  { name: "Indian Railways", file: "railways.png" },
  { name: "BPCL", file: "bpcl.png" },
  { name: "PDG Data Centre", file: "pdg.png" },
  { name: "Megha Engineering", file: "megha.png" },
];

const ClientBadge = ({ name, file }) => {
  const [imgOk, setImgOk] = useState(true);
  return (
    <div
      data-testid={`client-logo-${name}`}
      className="flex items-center justify-center h-16 px-4 grayscale opacity-70 hover:opacity-100 hover:grayscale-0 transition-all duration-300"
    >
      {imgOk ? (
        <img
          src={`/logos/${file}`}
          alt={`${name} logo`}
          className="max-h-10 max-w-[130px] object-contain"
          onError={() => setImgOk(false)}
        />
      ) : (
        <span className="font-heading text-lg sm:text-xl font-bold text-[#10193f] whitespace-nowrap">
          {name}
        </span>
      )}
    </div>
  );
};

export const ClientLogos = () => {
  return (
    <section className="py-16 bg-white border-b border-gray-200" data-testid="client-logos">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <p className="text-center text-xs font-bold uppercase tracking-widest text-[#8b8f99]">
          Trusted by India&apos;s Leading Infrastructure Companies
        </p>
        <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-x-6 gap-y-4 items-center">
          {clients.map((c) => (
            <ClientBadge key={c.name} {...c} />
          ))}
        </div>
      </div>
    </section>
  );
};
